import { Document, Packer, Paragraph, TextRun, SectionType, ImageRun, Header, Footer } from "docx";
import { buildApi } from "../../api";


export const saveByteArray = (() => {
    const a = document.createElement("a");
    document.body.appendChild(a);
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    if (isIE11) {
        const style = a.style;
        style.setAttribute('display', 'none');
        return (data, name) => {
            window.navigator.msSaveOrOpenBlob(new Blob(data), name);
        };
    }

    a.style = "display: none";
    return (data, name) => {
        const blob = new Blob(data, { type: "octet/stream" }), url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
    };
})();

const api = buildApi(({ get }) => ({
    getLogo: () => {
        return get({ path: 'images/logo_2x.png', _blob: true });
    }
}));

api.getLogo().then(res => res.blob()).then(b => { 
    return new Promise((resolve, reject) => {
        const f = new FileReader();
        f.onloadend = (e) => {
            if (e.target.readyState == FileReader.DONE) {
                resolve(e.target.result);
            }
        };
        f.readAsArrayBuffer(b);
    });
    
}).then(ab => {
    BaseExporter.imgBuffer = Buffer.from(ab);
});


export class BaseExporter {
    static imgBuffer = null;

    tagStyleProps = {
        firstLineIndent : "indent1=\"600\"",
        highlightIndent : "indent=\"600\"",
        redFontColor : "color=\"FF0000\"",
    };

    constructor(data) {
        this.data = data;
    }

    buildMainSection() {
        return undefined;
    }

    logoImageRun() {
        return new ImageRun({
            data: BaseExporter.imgBuffer,
            transformation: {
                width: 257, height: 61
            },
        });
    }


    buildHeaders() {
        return {
            first: new Header({
                children: []
            })
        };
    }

    buildFooters() {
        const footer = new Footer({
            children: []
        });
        return {
            default: footer,
            first: footer
        };
    }


    buildBase() {
        return {
            properties: {titlePage: true},
            headers: this.buildHeaders(),
            footers: this.buildFooters(),
            children: [
                new Paragraph({
                    children: [
                        new TextRun({
                            text: "Информация носит справочный характер и не может быть основанием для совершения юридически значимых действий.",
                            font: "Calibri",
                            size: 18,
                            color: "#555555"
                        })
                    ]
                }),
                new Paragraph({ children: [new TextRun({ text: "", size: 14 })] }),
                new Paragraph({ children: [this.logoImageRun()] }),
                new Paragraph({children: [new TextRun({text: "", size: 18})]}),
            ],
        };
    }

    buildDoc() {
        const sections = [this.buildBase()];
        const mainPart = this.buildMainSection();
        if (mainPart)
            sections.push(mainPart);
        sections.forEach(s => {
            s.properties = Object.assign({}, s.properties, {
                type: SectionType.CONTINUOUS,
                page: {
                    margin: {
                        top: 850,
                        right: 850,
                        bottom: 850,
                        left: 850,
                    },
                },
            });
        });
        return new Document({sections});
    }

    save(filename) {
        Packer.toBuffer(this.buildDoc()).then((buffer) => {
            saveByteArray([buffer], filename);
        });
    }

    getFullFilledTemplate(template, replaceMap) {
        const replaceCumulative = (str, replaceMap, prefix = "{", suffix = "}") => {
            Object.entries(replaceMap).forEach(([from_, to_]) => {
                str = str.replace(new RegExp(prefix + from_ + suffix, "g"), to_);
            });
            return str;
        };
        return replaceCumulative(template, replaceMap).replace(/&nbsp;/g, " ");
    }
}